/* eslint-disable no-unused-vars */
/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import PrivacyPolicyComponent from './footerLinks/PrivacyPolicyComponent';
import TermsOfUseComponent from './footerLinks/TermsOfUseComponent';
import BrowserReqComponent from './footerLinks/BrowserReqComponent';
import AccessibilityComplianceComponent from './footerLinks/AccessibilityComplianceComponent';
import { SITE_MAP } from '../../SharedModules/Navigation/RouteConstants';
import { handleScrollToEvent } from '../../SharedModules/CommonUtilities/commonUtilities';
import './contentManageFooter.css';

function FOOTERLINKS(props) {
  const { location } = props;
  useEffect(() => {
    handleScrollToEvent();
    if (location?.state === SITEMAP) {
      props.history.push(SITE_MAP);
    }
  }, [location]);

  return (
    <div className="tabs-container">
      <div className="tBillPanel custom-check">
        <div className="paneldevider-line ml-2">
          <Grid container>
            {location?.state === PRIVACY_POLICY ? (
              <PrivacyPolicyComponent />
            ) : location?.state === TERMS_OF_USE ? (
              <TermsOfUseComponent />
            ) : location?.state === BROWSER_REQUIREMENTS ? (
              <BrowserReqComponent />
            ) : location?.state === ACCESSIBILITY_COMPLIANCE ? (
              <AccessibilityComplianceComponent />
            ) : (
              ''
            )}
          </Grid>
        </div>
      </div>
    </div>
  );
}
export const PRIVACY_POLICY = 'PRIVACY_POLICY';
export const TERMS_OF_USE = 'TERMS_OF_USE';
export const BROWSER_REQUIREMENTS = 'BROWSER_REQUIREMENTS';
export const ACCESSIBILITY_COMPLIANCE = 'ACCESSIBILITY_COMPLIANCE';
export const SITEMAP = 'SITEMAP';

export default FOOTERLINKS;
